"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.TimecardTiles = void 0;
const react_1 = __importStar(require("react"));
const Card_1 = require("@amzn/atoz-web/Card");
const Text_1 = require("@amzn/atoz-web/Text");
const Col_1 = require("@amzn/atoz-web/Col");
const Row_1 = require("@amzn/atoz-web/Row");
const Icons_1 = require("@amzn/atoz-web/Icons");
const View_1 = require("@amzn/atoz-web/View");
const TimecardTilesTypes_1 = require("../../components/TimecardTiles/TimecardTilesTypes");
const WebUtils_1 = require("./WebUtils");
const Popover_1 = require("@amzn/atoz-web/Popover");
const Link_1 = require("@amzn/atoz-web/Link");
const Responsive_1 = require("@amzn/atoz-web/Responsive");
const react_i18next_1 = require("react-i18next");
const TimecardTiles = (props) => {
    const { matches } = (0, Responsive_1.useBreakpoints)();
    const { t } = (0, react_i18next_1.useTranslation)();
    const MAX_NUMBER_OF_TILES = 7;
    const redirectTiles = (0, WebUtils_1.getRedirectTiles)(props, 'web', t);
    const eligibleTileRedirects = redirectTiles.filter((redirectFeature) => redirectFeature.eligible && redirectFeature.position === TimecardTilesTypes_1.Position.TILE);
    const eligibleModalRedirects = redirectTiles.filter((redirectFeature) => redirectFeature.eligible && redirectFeature.position === TimecardTilesTypes_1.Position.POPOVER);
    while (eligibleTileRedirects.length > MAX_NUMBER_OF_TILES) {
        eligibleModalRedirects.push(eligibleTileRedirects.pop());
    }
    const renderListOfTiles = (tile) => {
        return (react_1.default.createElement(Col_1.Col, { alignItems: 'center', "flex-wrap": 'wrap', gridGap: 'S100', maxWidth: '64px' },
            react_1.default.createElement(Card_1.Card, { key: tile.label, dataTestId: tile.redirectUrl.split('/').pop(), role: 'RedirectTile', onClick: () => location.assign(tile.redirectUrl), alignItems: 'center', style: {
                    borderColor: 'neutral20',
                    borderRadius: '8px',
                    borderWidth: '1px'
                }, height: '64px', width: '64px' }, tile.icon),
            react_1.default.createElement(Text_1.Text, { textAlign: "center", fontSize: '12px' }, tile.label)));
    };
    const renderMoreTilesModal = () => {
        return (react_1.default.createElement(Col_1.Col, { backgroundColor: "neutral0", gridGap: "S500", padding: "S500", dataTestId: 'QuickLinksPopover', alignSelf: 'center', alignItems: 'center' }, eligibleModalRedirects.map((additionalTile, index) => (react_1.default.createElement(Link_1.Link, { key: index.toString(), dataTestId: additionalTile.redirectUrl.split('/').pop(), onClick: () => location.assign(additionalTile.redirectUrl), style: { width: '100%' }, fontSize: '16px' }, additionalTile.label)))));
    };
    const [isPopoverOpen, setIsPopoverOpen] = (0, react_1.useState)(false);
    const popoverTarget = (0, react_1.useRef)(null);
    return (react_1.default.createElement(View_1.View, { alignItems: "center", maxWidth: (matches.l || matches.xl) && '340px', dataTestId: 'TimecardTiles', padding: "1rem", flexWrap: 'wrap', alignSelf: 'center' },
        react_1.default.createElement(Row_1.Row, { gridGap: 16, flexWrap: 'Wrap' },
            eligibleTileRedirects
                .slice(0, MAX_NUMBER_OF_TILES)
                .map((link) => renderListOfTiles(link)),
            eligibleModalRedirects.length > 0 && (react_1.default.createElement(react_1.default.Fragment, null,
                react_1.default.createElement(Col_1.Col, { alignItems: 'center', "flex-wrap": 'wrap', gridGap: 'S100', maxWidth: '64px' },
                    react_1.default.createElement(Card_1.Card, { dataTestId: 'MoreTile', role: 'RedirectTile', onClick: () => setIsPopoverOpen(!isPopoverOpen), alignItems: 'center', style: {
                            borderColor: 'neutral20',
                            borderRadius: '8px',
                            borderWidth: '1px'
                        }, ref: popoverTarget, height: '64px', width: '64px' },
                        react_1.default.createElement(Icons_1.IconBulletedList, { title: 'More', color: "primary70", size: Icons_1.IconSize.Large })),
                    react_1.default.createElement(Text_1.Text, { fontSize: '12px' }, t('timecard_tiles_more_tile_label'))),
                react_1.default.createElement(Popover_1.PopoverController, { target: popoverTarget, isOpen: isPopoverOpen, close: close, position: Popover_1.PopoverPosition.BottomLeading, shouldCloseOnFocusLeave: true }, renderMoreTilesModal()))))));
};
exports.TimecardTiles = TimecardTiles;
